import React, { useState, useEffect } from "react";
import axios from "axios";
import Logo from '../logo.png';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import user_logo from "../user_logo.png"
import InformationPopup from './InformationPopup';
import LogoutButton from './LogoutButton';
import { GET_NOTIFICATIONS } from "./ApiDetails";

function Header() {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [isAdditionalPopupOpen, setIsAdditionalPopupOpen] = useState(false);
    const navigate = useNavigate();

    const firstName = localStorage.getItem('firstName');

    const [emailData, setEmailData] = useState();
    const [countOfNotification, setCountOfNotification] = useState();

    useEffect(() => {
        const getEmailNotification = async () => {
            try {
                const response = await axios.get(GET_NOTIFICATIONS);
                setEmailData(response.data);
                setCountOfNotification(response.data.length);
            } catch (error) {
                console.error("Error fetching family members:", error);
            }
        };
        getEmailNotification();
    }, []);

    const handleNotificationOpen = () => {
        const data = { message: emailData }; // Replace this with your actual data
        navigate(`/notification-page`, { state: data }); // Pass `data` in the state
    };


    const handlePopupOpen = () => {

        setIsAdditionalPopupOpen(true);

    };

    const handlePopupClose = () => {

        setIsAdditionalPopupOpen(false);

    };

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const boxStyle = {
        color: 'darkblue',
        borderRadius: '5px',
        padding: '5px 5px',
        border: '1px solid gainsboro',
        height: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    };

    const largeBoxStyle = {
        ...boxStyle,
        width: '230px'
    };


    return (
        <>
            <nav className="navbar navbar-expand-lg bg-body-tertiary">
                <div className="container-fluid container-Padding">
                    <div className="d-flex justify-content-start align-items-center">
                        <Link className="navbar-brand mb-0" to='/AppAdmin'>
                            <img src={Logo} alt="Logo" width="100" className="d-inline-block align-text-top" />
                        </Link>
                        <Link to={"/create"} className="buttonrequest ml-2">CREATE A NEW REQUEST</Link>
                    </div>
                    <div className="d-flex justify-content-end align-items-center position-relative adminHeaderButtonsContainer">
                        <Link to={"/eventReport"} className="btn d-flex align-items-center" style={largeBoxStyle}>
                            <FontAwesomeIcon icon={faCog} className="me-2" /> <span className='header-btn'> Administration & Reports</span>
                        </Link>
                        <div className="profile-dropdown d-flex align-items-center ms-3 adminHeaderButtonsContainer" onClick={toggleDropdown} style={{ ...largeBoxStyle, cursor: 'pointer' }}>

                            <img src={user_logo} className='userIcon' />

                            <span className='header-btn'>{firstName}</span>
                            <FontAwesomeIcon icon={faChevronDown} className="ms-2" />
                        </div>
                        {dropdownOpen && (
                            <div className="dropdown-menu show" style={{ position: 'absolute', top: '50px', right: '70px', left: 'auto', padding: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', zIndex: 1000, backgroundColor: '#ffffff', borderRadius: '5px', border: '1px solid gainsboro', fontSize: '12px' }}>
                                <ul className="list-group">
                                    <li className="list-group-item dropdown-title">CHOOSE A PROFILE TO ACT FOR</li>
                                    <li className="list-group-item">
                                        <svg className='dropdownUserIcon' width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0_4740_321)">
                                                <rect width="24" height="24" rx="12" fill="#0000A0" />
                                                <rect x="7" y="4" width="10" height="10" rx="5" fill="#00DCFA" />
                                                <rect x="-6" y="16" width="36" height="36" rx="18" fill="#00DCFA" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4740_321">
                                                    <rect width="24" height="24" rx="12" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <Link className='dropdown-items-text' to={`/AppAdmin`}>{firstName + " (as Admin)"}</Link>
                                    </li>
                                    <li className="list-group-item border-bottom">
                                        <svg className='dropdownUserIcon' width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0_4740_321)">
                                                <rect width="24" height="24" rx="12" fill="#0000A0" />
                                                <rect x="7" y="4" width="10" height="10" rx="5" fill="#00DCFA" />
                                                <rect x="-6" y="16" width="36" height="36" rx="18" fill="#00DCFA" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_4740_321">
                                                    <rect width="24" height="24" rx="12" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <Link className='dropdown-items-text' to={`/AppRequester`} onClick={() => localStorage.setItem('fromAdminMode', true)}><span>{firstName + " (as Requestor)"} </span></Link>
                                    </li>
                                </ul>
                            </div>
                        )}

                        {/* Bell Notification Icon */}
                        <span
                            className="badge"
                            style={{ fontSize: "12px", color: "darkblue", cursor: "pointer" }}
                            onClick={handleNotificationOpen}
                        >
                            <b className="header-btn">{countOfNotification}</b>
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M19.5 13.7246C19.125 11.8496 18.9 9.89961 18.675 8.02461C18.225 4.04961 16.05 2.09961 12.075 2.09961C8.1 2.09961 5.925 4.04961 5.475 8.02461C5.25 9.97461 4.95 11.8496 4.65 13.7246L3.75 18.7496H8.775C8.775 20.6246 10.275 22.0496 12.075 22.0496C13.875 22.0496 15.375 20.5496 15.375 18.7496H20.4L19.5 13.7246ZM7.125 8.17461C7.5 5.09961 8.925 3.74961 12.075 3.74961C15.15 3.74961 16.65 5.09961 17.025 8.17461C17.25 10.0496 17.475 11.9246 17.85 13.7246H6.3C6.675 11.9246 6.9 10.0496 7.125 8.17461ZM12.075 20.3996C11.175 20.3996 10.425 19.6496 10.425 18.7496H13.725C13.725 19.6496 12.975 20.3996 12.075 20.3996ZM5.7 17.0996L6 15.4496H18.075L18.375 17.0996H5.7Z"
                                    fill="#0000A0"
                                />
                            </svg>
                        </span>
                        {/* I information icon */}
                        <span className="badge" style={{ fontSize: '8px', color: 'darkblue', cursor: 'pointer' }} onClick={handlePopupOpen}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.8258 11.1758H11.1758V16.2008H12.8258V11.1758Z" fill="#0000A0" />
                                <path d="M12.8258 7.80078H11.1758V9.45078H12.8258V7.80078Z" fill="#0000A0" />
                                <path d="M12.0004 20.3254C16.5754 20.3254 20.3254 16.5754 20.3254 12.0004C20.3254 7.42539 16.5754 3.67539 12.0004 3.67539C7.42539 3.67539 3.67539 7.42539 3.67539 12.0004C3.67539 16.5754 7.42539 20.3254 12.0004 20.3254ZM12.0004 21.9754C6.45039 21.9754 2.02539 17.4754 2.02539 12.0004C2.02539 6.45039 6.52539 2.02539 12.0004 2.02539C17.5504 2.02539 21.9754 6.52539 21.9754 12.0004C21.9754 17.5504 17.5504 21.9754 12.0004 21.9754Z" fill="#0000A0" />
                            </svg>
                        </span>
                        <LogoutButton />
                        <InformationPopup isOpen={isAdditionalPopupOpen}
                            onClose={handlePopupClose}
                        />
                    </div>
                </div>
            </nav>
        </>
    );
}

export default Header;